<div class="top-nav-bar" [class.hide-buttons-and-avatars]="shouldHideButtonsAndAvatars" ui-row uiAlign="middle">
  <div class="top-nav-bar__toggle-nav border-right" *ngIf="!isNavExpanded" ui-col>
    <toggle-nav uiId="top-subnav-toggle" action="expand"></toggle-nav>
  </div>
  <div class="top-nav-bar__header-container" [class.top-nav-bar__title-container--pl-8]="!isNavExpanded" ui-col ui-row uiAlign="middle">
    <div class="top-nav-bar__title-container" data-test-id="page-title">
      <ng-container *ngIf="navSubTitle">
        <a class="top-nav-bar__subtitle" (keyup.enter)="actionHandler()" (keyup.space)="actionHandler()" (click)="actionHandler()" data-test-id="top-nav-bar-subtitle" ui-col tabindex="0">{{
          navSubTitle.text
        }}</a>
        <span class="top-nav-bar__title-divider" aria-hidden="true">/</span>
      </ng-container>
      <h2 class="top-nav-bar__title" [class.truncate-title]="shouldHideButtonsAndAvatars" [class.title-gray-background]="isGrayBackground" [attr.aria-label]="titleAriaLabel" ui-col>
        <ng-container *uiStringTemplateOutlet="navTitle">
          <span [tabindex]="navTitleTabIndex" data-test-id="top-nav-bar-title">
            {{ navTitle }}
          </span>
        </ng-container>
      </h2>
    </div>
    <div class="top-nav-bar__favorite" ui-col>
      <ng-content select="[top-nav-bar-favorite]"></ng-content>
    </div>
    <div class="top-nav-bar__dropdown" ui-col data-test-id="top-nav-bar-dropdown">
      <ng-content select="[top-nav-bar-dropdown]"></ng-content>
    </div>
    <div ui-col>
      <ng-content select="[top-nav-bar-loading-indicator]"></ng-content>
    </div>
    <top-nav-bar-tabs
      class="top-nav-bar__tabs-container"
      *ngIf="topNavBarTabsConfig"
      [tabs]="topNavBarTabsConfig"
      [initialActiveTabKey]="initialActiveTabKey"
      [isRelaxedMode]="elementsRelaxedMode"></top-nav-bar-tabs>
  </div>

  <div class="top-nav-bar__right-content sp-mr-24" ui-col ui-row uiJustify="end" uiAlign="middle">
    <top-nav-bar-avatars
      class="top-nav-bar__avatars-container"
      *ngIf="topNavBarAvatarsConfig && !shouldHideButtonsAndAvatars && visibleAvatarsCount !== 0"
      [config]="topNavBarAvatarsConfig"
      [visibleAvatarsCount]="visibleAvatarsCount"></top-nav-bar-avatars>

    <simple-permissions
      *ngIf="simplePermissionsConfig"
      [access]="simplePermissionsConfig.access"
      [ownerId]="simplePermissionsConfig.ownerId"
      [showPermissions]="simplePermissionsConfig.showPermissions"
      [compactMode]="!elementsRelaxedMode"
      [tabIndex]="-1"
      [shareableLink]="simplePermissionsConfig.shareableLink"
      [isGrayBackground]="simplePermissionsConfig.isGrayBackground"
      (toggle)="simplePermissionsConfig.toggleHandler($event)"
      (accessChange)="simplePermissionsConfig.accessChangeHandler($event)">
    </simple-permissions>

    <top-nav-bar-buttons
      class="top-nav-bar__buttons-container"
      *ngIf="topNavBarButtonsConfig"
      [isRelaxedMode]="elementsRelaxedMode"
      [buttonsConfig]="topNavBarButtonsConfig.buttonsConfig"
      [dropdownConfig]="topNavBarButtonsConfig.dropdownConfig"
      ui-col></top-nav-bar-buttons>

    <ng-container>
      <div class="top-nav-bar__buttons-container" *ngIf="elementsRelaxedMode" ui-col>
        <ng-content select="[top-nav-bar-button-relaxed]"></ng-content>
      </div>
      <div class="top-nav-bar__buttons-container" *ngIf="!elementsRelaxedMode" ui-col>
        <ng-content select="[top-nav-bar-button-compact]"></ng-content>
      </div>
    </ng-container>
    <ng-container *ngIf="!hideGlobalSearch">
      <global-search [facet]="searchFacet" (globalSearchToggle)="onGlobalSearchToggle($event)" ui-col />
    </ng-container>
  </div>
</div>
